import { hot } from 'react-hot-loader/root';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/react-common';
import 'focus-visible/dist/focus-visible';

import './theme';
import getApolloClient from './apollo-client';
import setupUserStore from './user-store';
import idpService from './idp';
import App from './containers/App';
import history from './history';
import routes from './routes';

import { translationMessages } from './i18n';
import LanguageProvider from './providers/LanguageProvider';
import PageTitleProvider from './providers/PageTitleProvider';
import setupGA from './configureGA';

const appDom = document.getElementById('app');
const HotApp = hot(App);

console.log(`Starting HS App @ ${process.env.VERSION}, built ${process.env.BUILDTIME} from ${process.env.BUILDBRANCH}`); // eslint-disable-line no-console

const renderUI = (store) => {
  const client = getApolloClient(store);
  if (process.env.A11Y) {
    require('./a11y').default(appDom); // eslint-disable-line global-require
  }
  ReactDOM.render(
    <Provider store={store}>
      <LanguageProvider messages={translationMessages}>
        <ApolloProvider client={client}>
          <PageTitleProvider>
            <Router history={history}>
              <HotApp idleTimeout={process.env.IDLE_TIMEOUT}>
                {routes}
              </HotApp>
            </Router>
          </PageTitleProvider>
        </ApolloProvider>
      </LanguageProvider>
    </Provider>,
    appDom,
  );
};

setupGA(history);
// check with naviance idp to see if it is a callback with implict Oauth 2.0 flow.
const userData = idpService.processIdpCallback();
if (userData) {
  setupUserStore(userData, renderUI);
} else {
  setupUserStore(null, renderUI);
}
